import { render } from "./SongList.vue?vue&type=template&id=5f151130&scoped=true"
import script from "./SongList.vue?vue&type=script&lang=ts"
export * from "./SongList.vue?vue&type=script&lang=ts"

import "./SongList.vue?vue&type=style&index=0&id=5f151130&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f151130"

export default script